/*** IMPORTS FROM imports-loader ***/
var $ = window.jQuery;

// removed by extract-text-webpack-plugin



//////////////////
// WEBPACK FOOTER
// ./node_modules/imports-loader?$=>window.jQuery!./src/wp-migrate-db-pro-multisite-tools/asset/src/sass/styles.scss
// module id = 76
// module chunks = 0